import React, {ReactNode} from 'react'
import {HRVSummaryResponse} from 'api/analysisApi'
import HRVSummaryAutoNervousSystemAPI from 'components/molcules/N1SummaryReport/HRV/HRVSummaryAutoNervousSystemAPI'
import HRVSummaryStressAPI from 'components/molcules/N1SummaryReport/HRV/HRVSummaryStressAPI'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'
import useLanguage from 'features/languageReport/useLanguage'
import HRVSummarySentimentalAPI from './HRVSummarySentimentalAPI'

interface HRVSummaryProps extends HRVSummaryResponse {
  CustomerCard?: ReactNode
  customerFirstName: string
  customerLastName: string
  autoNervousSystemBalance: {
    parasympathetic: number
    sympathetic: number
  }
}

export default function HRVSummaryAPI(props: HRVSummaryProps) {
  const {
    circularImage,
    depression,
    phase,
    anxiety,
    CustomerCard,
    customerFirstName,
    customerLastName,
    reportType,
    autoNervousSystemBalance,
  } = props

  const classes = useStyles()
  const {textHrvAPI} = useLanguage('hrv')
  const currentBalanceStageNumber =
    textHrvAPI?.autonomic_nervous_system_stress_analysis.section
      .automatic_nervous_balance.number ?? 1
  const balanceOpinionText =
    textHrvAPI?.autonomic_nervous_system_stress_analysis.section.automatic_nervous_balance.analysis_results.opinions[
      `stage${currentBalanceStageNumber}`
    ]
      .replace('{1}', String(autoNervousSystemBalance.sympathetic))
      .replace('{2}', String(autoNervousSystemBalance.parasympathetic)) ?? ''

  return (
    <div className={classes.root}>
      {CustomerCard}
      {/* Basic analysis */}
      <HRVSummaryAutoNervousSystemAPI
        customerFirstName={customerFirstName}
        customerLastName={customerLastName}
        balanceCircularImagePath={circularImage}
        balanceOpinion={balanceOpinionText}
      />
      {/* Premium analysis */}
      {reportType === 'P2' && <HRVSummaryStressAPI phase={phase} />}
      {reportType === 'P2' && (
        <HRVSummarySentimentalAPI
          depression={depression}
          anxiety={anxiety}
          customerFirstName={customerFirstName ?? ''}
          customerLastName={customerLastName ?? ''}
        />
      )}

      <p className='Warning'>
        {`${textHrvAPI?.footer[0]} ${textHrvAPI?.footer[1]}`}
      </p>
    </div>
  )
}
